import React, {createContext, useState} from 'react'


const Provider = ({children}) => {

 let obj = {

   currentTabla: [],

   TotalkWhBim: 0,

   TotalImporteBim: 0,

   clearDropdowns: false,
   
   ValoresCategoriaCard: {
     "Climatización": 
     { "kWh": 0, "Cant": 0 },

     "Electrónica, Audio y Video":
     { "kWh": 0, "Cant": 0 },

     "Cocina": 
     { "kWh": 0, "Cant": 0 },

     "Línea Blanca": 
     { "kWh": 0, "Cant": 0 },

     "Agua": 
     { "kWh": 0, "Cant": 0 },

     "Iluminación": 
     { "kWh": 0, "Cant": 0 },

     "Refrigeración": 
     { "kWh": 0, "Cant": 0 },

     "Maquinaria": 
     { "kWh": 0, "Cant": 0 },
     
     "Cuidado Personal": 
     { "kWh": 0, "Cant": 0 },
   },
   
   tablasPorCategoria: {
    "Climatización": [],

     "Electrónica, Audio y Video": [],

     "Cocina": [],

     "Línea Blanca": [],

     "Agua": [],

     "Iluminación": [],

     "Refrigeración": [],

     "Maquinaria": [],
     
     "Cuidado Personal": [],
   }
 };

  const [valoresConsumoState, setValoresConsumoState] = useState(obj);

  return (
    <AppContext.Provider value={[valoresConsumoState, setValoresConsumoState]}>
      {children}
    </AppContext.Provider>
  );
}

export default Provider
export const AppContext = createContext();